import { Moon, Sun } from 'lucide-react';
import { DropdownMenu } from '@vizial-ui/components';

import { useAppSettingsStore, type Theme } from '../../store/appSettingsStore';
import styles from './ThemeSwitcher.module.css';

const THEME_OPTIONS: { value: Theme; label: string }[] = [
  { value: 'secure-agility', label: 'Light' },
  { value: 'secure-agility-dark', label: 'Dark' },
];

export function ThemeSwitcher() {
  const theme = useAppSettingsStore((state) => state.settings.theme);
  const setTheme = useAppSettingsStore((state) => state.setTheme);

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className={styles.trigger}
          aria-label="Switch theme"
        >
          {theme === 'secure-agility-dark' ? (
            <Moon size={18} />
          ) : (
            <Sun size={18} />
          )}
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end" sideOffset={8}>
        <DropdownMenu.RadioGroup
          value={theme}
          onValueChange={(value) => setTheme(value as Theme)}
        >
          {THEME_OPTIONS.map((option) => (
            <DropdownMenu.RadioItem key={option.value} value={option.value}>
              {option.label}
            </DropdownMenu.RadioItem>
          ))}
        </DropdownMenu.RadioGroup>
      </DropdownMenu.Content>
    </DropdownMenu>
  );
}
